import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";

const Header = () => {
  const { locationId, templateId } = useParams() || {};
  const [menuOpen, setMenuOpen] = useState(false);

  const showNavLinks = locationId && templateId;

  return (
    <div className="headerContainer">
      <div className="container-fluid">
        <div className="logoContainer">
          <nav className="navbar navbar-expand-lg fixed-top w-100">
            <div className="container-fluid header-nav-container">
              <Link to="/" className="navbar-brand" onClick={() => setMenuOpen(false)}>
                <h1>Bowinkles Drive Thru</h1>
              </Link>
              <button
                className="navbar-toggler"
                type="button"
                aria-controls="basic-navbar-nav"
                aria-expanded={menuOpen}
                aria-label="Toggle navigation"
                onClick={() => setMenuOpen(!menuOpen)}
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <div
                className={`navbar-collapse collapse ${menuOpen ? "show" : ""}`}
                id="basic-navbar-nav"
              >
                {showNavLinks && (
                  <ul className="navbar-nav nav-center">
                    <li className="nav-item">
                      <Link
                        to={`/location/${locationId}/${templateId}/menu`}
                        className="nav-link"
                        onClick={() => setMenuOpen(false)}
                      >
                        Menu
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        to={`/location/${locationId}/${templateId}/contact`}
                        className="nav-link"
                        onClick={() => setMenuOpen(false)}
                      >
                        Contact
                      </Link>
                    </li>
                  </ul>
                )}
                <ul className="navbar-nav nav-right">
                  <li className="nav-item">
                    {templateId === "1" ? (
                      <div className="contact-info">
                        <a className="telephone" href="tel:9169919996">
                          <i className="fas fa-phone-alt"></i>
                          <span>(916) 991-9996</span>
                        </a>
                        <a
                          className="address"
                          href="https://www.openstreetmap.org/search?query=912+Oak+Ln,+Rio+Linda,+CA+95673"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fas fa-map-marker-alt"></i>
                          <span>912 Oak Ln, Rio Linda, CA 95673</span>
                        </a>
                      </div>
                    ) : (
                      <div className="contact-info">
                        <a className="telephone" href="tel:9168551111">
                          <i className="fas fa-phone-alt"></i>
                          <span>(916) 855-1111</span>
                        </a>
                        <a
                          className="address"
                          href="https://www.openstreetmap.org/search?query=10423+Folsom+Blvd,+Rancho+Cordova,+CA+95670"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fas fa-map-marker-alt"></i>
                          <span>10423 Folsom Blvd, Rancho Cordova, CA 95670</span>
                        </a>
                      </div>
                    )}
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Header;
